import React, { useState } from "react";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import "./Weather.css";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      date: new Date(response.data.time* 1000),
      coordinates: response.data.coordinates,
      temperature: response.data.temperature.current,
      humidity: response.data.temperature.humidity,
      description: response.data.condition.description,
      icon: response.data.condition.icon,
      wind: response.data.wind.speed,
      city: response.data.city,
      feels_like: response.data.temperature.feels_like,

    });
  }

  function search() {
    const apiKey = "b7ea8b401f32t19a93ao15f325c763f2";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="container">
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input type="search"  placeholder="Type a city..."  className="search-input form-control"  autoFocus="on"  onChange={handleCityChange} />
            </div>
            <div className="col-3">
              <input type="submit"  value="search" className="btn w-100"/>
            </div>
          </div>
        </form>
          <WeatherInfo data={weatherData} />
          <WeatherForecast coordinates={weatherData.coordinates} city={weatherData.city} />
          <footer>
          Graphic designer and coding by{" "}
        <a href="https://nargesfalahat.netlify.app/" target="_blank" rel="noopener noreferrer">
          Narges Falahat
        </a>
      </footer>
      </div>
      </div>
    );
  } else {
    search();
    return (
       <div id="loading">
          <div>W</div>
          <div>E</div>
          <div>A</div>
          <div>T</div>
          <div>H</div>
          <div>E</div>
          <div>R</div>
       </div>
      );
  }
}